export default "__VITE_ASSET__a9DKvRaC__"